import { CardMedia, Grid, Box } from "@mui/material";
import { DESKTOP_NEW_FEATURE_DATA, MOBILE_NEW_FEATURE_DATA } from "../utils/dataNewFeature";
import { useState, useEffect } from "react";

const NewFeature = () => {
  const [windowWidth, setWindowWidth] = useState(typeof window !== 'undefined' ? window.innerWidth : 1200);
  const isMobile = windowWidth <= 768;
  
  // เลือกข้อมูลตาม device
  const data = isMobile ? MOBILE_NEW_FEATURE_DATA : DESKTOP_NEW_FEATURE_DATA;
  
  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <Box sx={{ 
      mb: { xs: 6, md: 12 },
      px: { xs: 1, md: 3 }
    }}>
      {/* =================== HEADER SECTION =================== */}
      <Grid
        container
        spacing={{ xs: 2, md: 3 }}
        justifyContent="center"
        className="new-feature-grid">
        {/* Header Section - Desktop Only */}
        <Grid
          item
          xs={12}
          data-aos="fade-down"
          sx={{ 
            mb: 4,
            display: { xs: "none", md: "block" }
          }}>
            <Box sx={{ 
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                maxWidth: { md: "80%", lg: "70%", xl: "60%" },
                mx: "auto",
                p: { md: 3, lg: 4, xl: 5 }
                }}>
            <CardMedia
              component="img"
              image={data.headerfirst}
              alt="Header page 1"
              sx={{
                width: "auto",
                height: { md: "160px", lg: "180px", xl: "200px" },
                objectFit: "contain",
                flexShrink: 0,
                mr: 2,
                p: { md: 1.5, lg: 1.75, xl: 2 }
              }}
            />
          </Box>
        </Grid>

        {/* Desktop: แสดงภาพใหญ่ภาพเดียว */}
        <Grid
          item
          xs={12}
          md={10}
          data-aos="fade-right"
          className="main-desktop-image"
          sx={{ display: { xs: "none", md: "block" } }}>
          <CardMedia
            component="img"
            image={data.mainfirst}
            alt="Main desktop image"
            sx={{
              width: "100%",
              mx: "auto",
              display: "block",
              height: "auto",
              objectFit: "contain",
              borderRadius: { md: 2, lg: 3 },
              mt: { md: -2, lg: -3 }
            }}
          />
        </Grid>

        {/* Mobile View */}
        <Grid
          item
          xs={12}
          data-aos="fade-right"
          className="main-mobile-images"
          sx={{ 
            display: { xs: "block", md: "none" },
            mt: { xs: 2, sm: 3 }
          }}>
          <Box sx={{
            display: "flex",
            flexDirection: "column",
            gap: { xs: 2, sm: 3 },
            px: { xs: 2, sm: 3 },
            py: { xs: 2, sm: 3 },
            pt: { xs: 2, sm: 3 }
          }}>
            {/* Headerfirst Image */}
            <CardMedia
              component="img"
              image={data.headerfirst}
              alt="Mobile headerfirst image"
              sx={{
                width: { xs: "100%", sm: "90%" },
                height: { xs: "auto", sm: "120px" },
                borderRadius: { xs: 1, sm: 2 },
                objectFit: "contain",
                display: "block",
                mx: "auto",
                border: "none",
                backgroundColor: "transparent",
                mb: { xs: 2, sm: 3 },
                mt: { xs: 2, sm: 3 }
              }}
            />
            
            {/* Mainfirst Images */}
            {Array.isArray(data.mainfirst) ? data.mainfirst.map((image, index) => (
              <CardMedia
                key={index}
                component="img"
                image={image}
                alt={`Mobile mainfirst image ${index + 1}`}
                sx={{
                  width: "100%",
                  height: { xs: "auto", sm: "200px" },
                  borderRadius: { xs: 1, sm: 2 },
                  objectFit: "contain",
                  display: "block",
                  border: "none",
                  backgroundColor: "transparent"
                }}
              />
            )) : (
              <CardMedia
                component="img"
                image={data.mainfirst}
                alt="Mobile mainfirst image"
                sx={{
                  width: "100%",
                  height: { xs: "auto", sm: "200px" },
                  borderRadius: { xs: 1, sm: 2 },
                  objectFit: "contain",
                  display: "block",
                  border: "none",
                  backgroundColor: "transparent"
                }}
              />
            )}
          </Box>
        </Grid>
      </Grid>

      {/* =================== PAGE 2 =================== */}
      <Box sx={{ display: "block" }}>
        <Grid 
          container 
          spacing={{ xs: 2, md: 3, lg: 4 }} 
          className="new-feature-grid"
          sx={{ px: { xs: 2, sm: 4, md: 6, lg: 8 } }}
        >
          {/* Header Page 2 */}
          <Grid item xs={12} sx={{ mb: { xs: 2, sm: 3, md: 4, lg: 6 } }} data-aos="fade-down">
            <CardMedia
              component="img"
              image={data.headersecond}
              alt="Header page 2"
              sx={{
                width: { xs: "100%", sm: "90%", md: "60%", lg: "50%", xl: "40%" },
                maxWidth: { xs: 400, sm: 600, md: 1000, lg: 1200, xl: 1400 },
                height: "auto",
                mx: "auto",
                display: "block",
                objectFit: "contain",
                marginTop: { xs: 4, sm: 6, md: 10, lg: 12, xl: 14 }
              }}
            />
          </Grid>

          {/* Mobile Layout - Vertical Stack */}
          <Box sx={{ 
            display: { xs: "block", md: "none" }, 
            width: "100%",
            px: { xs: 2, sm: 3 }
          }}>
            <Grid container spacing={{ xs: 3, sm: 4 }}>
              {data.mainsecond.map((imageUrl, index) => (
                <Grid 
                  item 
                  xs={12} 
                  key={index}
                  data-aos-delay={index * 150}
                  sx={{ 
                    mb: { xs: 2, sm: 3 },
                    display: "flex",
                    justifyContent: "center"
                  }}
                >
                  <Box sx={{
                    width: "100%",
                    maxWidth: { xs: 450, sm: 550 },
                    mx: "auto",
                    position: "relative"
                  }}>
                    <CardMedia
                      component="img"
                      image={imageUrl}
                      alt={index === 5 ? "Mobile feature - Annual Report" : `Mobile feature ${index + 1}`}
                      onClick={index === 5 ? () => window.open("https://cfl.gpf.or.th/Files/Viewer/?fileName=c6a4db6c-0ed2-4ea0-971b-ac40089f20e1/GPF-Annual-Report-2024-(1)-83-87.pdf", "_blank") : undefined}
                      sx={{
                        width: "auto",
                        height: { xs: "auto", sm: 250 },
                        objectFit: "contain",
                        borderRadius: { xs: 2, sm: 3 },
                        mx: "auto",
                        display: "block",
                        transition: "all 0.3s ease",
                        cursor: index === 5 ? "pointer" : "default",
                        "&:hover": index === 5 ? {
                          transform: "scale(1.05)",
                          opacity: 0.9
                        } : {}
                      }}
                    />
                  </Box>
                </Grid>
              ))}
            </Grid>
          </Box>

          {/* Desktop Layout - 3 columns */}
          <Box sx={{ 
            display: { xs: "none", md: "flex" }, 
            width: "100%",
            gap: 3,
            justifyContent: "center",
            alignItems: "flex-start",
            maxWidth: { md: 1200, lg: 1400, xl: 1600 },
            mx: "auto"
          }}>
            {/* Column 1: P90/P75/P50 Box */}
            <Grid 
              item 
              md={4}
              data-aos="fade-right"
              >
              <CardMedia
                component="img"
                image={data.mainsecond[0]}
                alt="P90 P75 P50 Box and Graph Phone"
                sx={{ 
                  width: "100%", 
                  height: 550,
                  objectFit: "contain",
                  borderRadius: { md: 2, lg: 3 }
                }}
              />
            </Grid>

            {/* Column 2: Timeline Phone */}
            <Grid
              item
              md={3}
              data-aos="fade-up"
              sx={{ display: "flex", alignItems: "center" }}
              >
              <CardMedia
                component="img"
                image={data.mainsecond[1]}
                alt="Timeline Phone"
                sx={{ 
                  width: "100%", 
                  height: 550,
                  objectFit: "contain", 
                  borderRadius: { md: 2, lg: 3 }
                }}
              />
            </Grid>

            {/* Column 3: Info Boxes */}
            <Grid
              item
              md={4}
              data-aos="fade-left"
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                height: 550,
                gap: 2
              }}>
              {/* MLS Definition Box */}
              <CardMedia
                component="img"
                image={data.mainsecond[2]}
                alt="MLS Definition Box"
                sx={{ 
                  width: "100%", 
                  height: "auto",
                  objectFit: "contain", 
                  borderRadius: { md: 2, lg: 3 }
                }}
              />

              {/* Assumptions Box */}
              <CardMedia
                component="img"
                image={data.mainsecond[3]}
                alt="Assumptions Box"
                sx={{ 
                  width: "100%", 
                  height: 120,
                  objectFit: "contain", 
                  borderRadius: { md: 2, lg: 3 }
                }}
              />

              {/* Study Details + Button */}
              <Grid container alignItems="center" spacing={2} sx={{ flex: 1 }}>
                <Grid item xs={8}>
                  <CardMedia
                    component="img"
                    image={data.mainsecond[4]}
                    alt="Study details"
                    sx={{ 
                      width: "100%", 
                      height: 120,
                      objectFit: "contain",
                      borderRadius: { md: 2, lg: 3 }
                    }}
                  />
                </Grid>
                <Grid item xs={4}>
                  <CardMedia
                    component="img"
                    image={data.mainsecond[5]}
                    alt="Button"
                    onClick={() => window.open("https://cfl.gpf.or.th/Files/Viewer/?fileName=c6a4db6c-0ed2-4ea0-971b-ac40089f20e1/GPF-Annual-Report-2024-(1)-83-87.pdf", "_blank")}
                    sx={{ 
                      width: "100%", 
                      height: 120,
                      objectFit: "contain",
                      borderRadius: { md: 2, lg: 3 },
                      cursor: "pointer",
                      transition: "all 0.3s ease",
                      "&:hover": {
                        transform: "scale(1.05)",
                        opacity: 0.9
                      }
                    }}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Box>
        </Grid>
      </Box>

      {/* =================== PAGE 3 =================== */}
      <Box sx={{ display: "block" }}>
        <Grid
          container
          spacing={{ xs: 2, md: 3, lg: 4 }}
          justifyContent="center"
          className="new-feature-grid">
          {/* Header Page 3 */}
          <Grid item xs={12} sx={{ mb: { xs: 2, sm: 3, md: 4, lg: 6 } }} data-aos="fade-down">
            <CardMedia
              component="img"
              image={data.headerthird}
              alt="Header page 3"
              sx={{
                width: { xs: "100%", sm: "90%", md: "60%", lg: "50%", xl: "40%" },
                maxWidth: { xs: 400, sm: 600, md: 1000, lg: 1200, xl: 1400 },
                height: "auto",
                mx: "auto",
                display: "block",
                objectFit: "contain",
                marginTop: { xs: 4, sm: 6, md: 10, lg: 12, xl: 14 }
              }}
            />
          </Grid>

          {/* Mobile Layout - Vertical Stack */}
          <Box sx={{ 
            display: { xs: "block", md: "none" }, 
            width: "100%",
            px: { xs: 2, sm: 3 }
          }}>
            <Grid container spacing={{ xs: 3, sm: 4 }}>
              {data.mainthird.map((imageUrl, index) => (
                <Grid 
                  item 
                  xs={12} 
                  key={index}
                  data-aos-delay={index * 150}
                  sx={{ 
                    mb: { xs: 2, sm: 3 },
                    display: "flex",
                    justifyContent: "center"
                  }}
                >
                  <Box sx={{
                    width: "100%",
                    maxWidth: { xs: 400, sm: 500 },
                    mx: "auto",
                    position: "relative"
                  }}>
                    <CardMedia
                      component="img"
                      image={imageUrl}
                      alt={`Mobile feature ${index + 1}`}
                      sx={{
                        width: "100%",
                        height: { xs: "auto", sm: 250 },
                        objectFit: "contain",
                        borderRadius: { xs: 2, sm: 3 },
                        mx: "auto",
                        display: "block",
                      }}
                    />
                  </Box>
                </Grid>
              ))}
            </Grid>
          </Box>

          {/* Desktop Layout - 2 columns */}
          <Box sx={{ 
            display: { xs: "none", md: "flex" }, 
            width: "100%",
            gap: 4,
            justifyContent: "center",
            alignItems: "center",
            maxWidth: { md: 1200, lg: 1400, xl: 1600 },
            mx: "auto",
            px: { md: 2, lg: 3, xl: 4 }
          }}>
            {/* Phone Image */}
            <Grid 
              item 
              md={5} 
              data-aos="fade-right"
              sx={{ display: "flex", justifyContent: "center" }}
            >
              <CardMedia
                component="img"
                image={data.mainthird[0]}
                alt="Phone preview"
                sx={{
                  width: "100%",
                  height: 550,
                  maxWidth: { md: 400, lg: 450, xl: 500 },
                  objectFit: "contain",
                  borderRadius: { md: 2, lg: 3 }
                }}
              />
            </Grid>

            {/* Feature List */}
            <Grid 
              item 
              md={7} 
              data-aos="fade-left"
              sx={{ display: "flex", justifyContent: "center" }}
            >
              <CardMedia
                component="img"
                image={data.mainthird[1]}
                alt="Feature list"
                sx={{
                  width: "100%",
                  height: 550,
                  objectFit: "contain",
                  borderRadius: { md: 2, lg: 3 }
                }}
              />
            </Grid>
          </Box>
        </Grid>
      </Box>
    </Box>
  );
};

export default NewFeature;
